// Тексты экрана Garmin: прогресс догрузки, строка журнала синхронизаций, пропущенные метрики.

import { pluralRu } from '@/lib/format'

import type { GarminStatus, SyncRun } from './api'

export const PART_LABELS: Record<string, string> = {
  sleep: 'сон',
  summary: 'шаги и калории',
  hrv: 'ВСР',
  stress: 'стресс',
  body_battery: 'Body Battery',
  readiness: 'готовность',
  resting_hr: 'пульс покоя',
  vo2max: 'VO2max',
  training_status: 'training status',
}

export const RUN_KIND_LABELS: Record<string, string> = {
  recent: 'по расписанию',
  manual: 'вручную',
  backfill: 'история',
}

export const RUN_STATUS_LABELS: Record<string, string> = {
  running: 'идёт',
  ok: 'готово',
  error: 'ошибка',
  rate_limited: 'лимит Garmin',
  expired: 'вход устарел',
}

export function backfillText(backfill: GarminStatus['backfill']): string {
  if (backfill.done) return `История за ${backfill.total} ${pluralRu(backfill.total, ['день', 'дня', 'дней'])} загружена`
  return `Загружено ${backfill.loaded} из ${backfill.total} ${pluralRu(backfill.total, ['дня', 'дней', 'дней'])}`
}

/** Какие части Garmin не отдал хотя бы за один день запуска. */
export function noDataParts(run: SyncRun): string[] {
  const days = run.summary?.days ?? {}
  const missing = new Set<string>()
  for (const parts of Object.values(days)) {
    for (const [part, value] of Object.entries(parts)) {
      if (value !== 'ok') missing.add(part)
    }
  }
  return Object.keys(PART_LABELS).filter((p) => missing.has(p)).map((p) => PART_LABELS[p]!)
}

/** «2 дня, записей 27, активностей 1» — что загружено за запуск. */
export function runLoaded(run: SyncRun): string {
  const days = Object.keys(run.summary?.days ?? {}).length
  const written = run.summary?.written ?? 0
  const acts = run.summary?.activities ?? 0
  const parts: string[] = []
  if (days) parts.push(`${days} ${pluralRu(days, ['день', 'дня', 'дней'])}`)
  parts.push(`записей ${written}`)
  if (acts) parts.push(`активностей ${acts}`)
  return parts.join(', ')
}

export function needsLogin(status: GarminStatus | undefined): boolean {
  return !status || status.status === 'disconnected' || status.status === 'expired'
}
